import angular from 'angular';

let fastSearchModule = angular.module('app.catalog.fastSearch', []);

export default fastSearchModule;



/** WEBPACK FOOTER **
 ** C:/wamp64/www/FRONTENDS/PROYECTOS SIESA/Projects_Azure/motos_paisa/NUEVO/motos-y-motos-el-paisa/www/components/catalog/fast-search/fast-search.js
 **/